import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { QUERY_KEY } from "../../constants";
import {
    _api_get_list_history_paid_expenses,
    _api_get_list_to_verify_expenses,
} from "../../api";
import {
    useLocation,
    useNavigate,
    useParams,
    useSearchParams,
} from "react-router-dom";
import { func_format_data_rows } from "./functions";
import useToast from "../../../../hooks/useToast";
import { useMediaQuery } from "react-responsive";
import { SIZES } from "../../../../constants/responsive";

const useLogic = ({ enabled = false }) => {
    // navigation
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { role } = useParams();
    // get params
    const location = useLocation();
    // affichage des ROWS
    const [rows, setRows] = useState([]);
    // state for toast
    const [show, setShow] = useToast({
        visible: location.state?.visible ?? false,
        content: location.state?.content ?? "",
        level: location.state?.level ?? "success",
    });

    const isMobileS = useMediaQuery({
        query: `(max-width: ${SIZES.mobileM})`,
    });
    const isMobileM = useMediaQuery({
        query: `(max-width: ${SIZES.mobileL})`,
    });
    const isMobileL = useMediaQuery({
        query: "(max-width: 455px)",
    });

    const isMobile = isMobileS || isMobileM || isMobileL;
    // QUERIES
    const { data, isLoading, isFetching } = useQuery(
        [
            QUERY_KEY + "::getListToVerifyExpenses",
            searchParams.toString(),
            role,
        ],
        (data) => {
            const path_file = data.queryKey.at(1);
            const path_role = data.queryKey.at(2);
            return _api_get_list_to_verify_expenses(path_file, path_role);
        },
        {
            enabled,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            onSuccess: (response) => {
                const format_rows = func_format_data_rows(
                    response,
                    navigate,
                    isMobile,
                    role
                );
                setRows(format_rows);
            },
        }
    );

    // RETURNS
    return {
        rows,
        setRows,
        toast: {
            show,
            setShow,
        },
        query: { data, isLoading, isFetching },
    };
};

export default useLogic;
